<template>
  <div class="indexs">
    <Seacher @search="searchs"></Seacher>

    <div class="content_top" id="list">
      <div class="head">NFT Details</div>
      <div class="headimg"><img :src="image" /></div>
      <div class="head">{{ itemName }}{{ tokenId }}</div>
      <div class="content_center centers">
        <div class="block_height">
          <div class="block_tit">Collection :</div>
          <div class="block_con" @click="Overview(contractAddress)">
            <span style="color:#fff;">{{ contractName }}</span>
          </div>
        </div>
        <div class="block_height">
          <div class="block_tit">TokenID :</div>
          <div class="block_con" style="color: #8d8d8d;">{{ tokenId }}</div>
        </div>
        <div class="block_height bkheight">
          <div class="block_tit">Contract :</div>
          <div class="block_con" @click="Overview(contractAddress)">
            {{ contractAddress }}
          </div>
        </div>
        <div class="block_height">
          <div class="block_tit">Owner :</div>
          <div class="block_con" @click="goDetail('transfer',owner)">{{ owner }}</div>
        </div>
        <div class="block_height" style="border-bottom: none;">
          <div class="block_tit">Creator :</div>
          <div class="block_con blockconss" @click="goDetail('transfer',creator)">
            {{ creator }}
          </div>
        </div>
        <!-- <div class="block_height disx">
          <div class="block_tit">Assets :</div>
          <div class="block_cona">
            {{ image }}
          </div>
        </div> -->
        <!-- <div class="block_height borernone">
          <div class="block_tit">Earned Bonus :</div>
          <div class="block_con">232 TTOS</div>
        </div> -->
      </div>
    </div>
    <!-- translist start -->
    <div class="translist">
      <!-- <div class="Block_Top notranslate">
        <span class="notranslate">Accounts</span>
      </div> -->
      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="tabbox">Item Activity</div>
            </div>
            <div class="indexContent">
              <div>
                <!-- translist start -->

                <div class="resume-list">
                  <div class="pool_main">
                    <div class="tags">
                      <div class="indexList">
                        <div class="Block_list1">
                          <ul class="block_list_Top1">
                            <li>Hash</li>
                            <li>Type</li>
                            <li>Age</li>
                            <li>From</li>
                            <li>To</li>
                            <li>Amount</li>
                          </ul>
                        </div>
                        <div class="Block_List_center1 notranslate">
                          <ul>
                            <li v-for="(item, index) in executeiList" :key="index">
                              <!-- <li v-for="(item, index) in 20" :key="index"> -->
                              <p @click="goDetail('hash',item)">{{ item.txHash }}</p>
                              <p>{{ item.functions }}</p>
                              <p>{{ item.tradeTime }}</p>
                              <p @click="goDetail('transfer',item.fromEvmAddress1)">{{ item.fromEvmAddress }}</p>
                              <p @click="goDetail('transfer',item.toEvmAddress1)">{{ item.toEvmAddress }}</p>
                              <p>{{ item.tokenAmount }}</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="block">
                    <el-pagination
                      background
                      small
                      :current-page.sync="pageNum"
                      :page-size="20"
                      :pager-count="5"
                      layout="prev, pager, next"
                      @current-change="handleCurrentChange"
                      :total="total"
                    >
                    </el-pagination>
                  </div>
                </div>

                <!-- translist end -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- translist end -->
  </div>
</template>

<script>
import Seacher from "@/components/m/Seacher.vue";
import { formatSeconds, getSubStr } from "@/utils/utils";
import { NftItemDetail } from "@/assets/server/api";
import { listTypea } from "../../utils/utils.js";
const echarts = require("echarts");
export default {
  components: {
    Seacher,
  },
  data() {
    return {
      pageSize: 0,
      total: null,
      pageNum: 1,
      pagerCount: 0,
      contractAddress: "",
      tokenId: "",
      list1: [],
      owner: "",
      image: "",
      itemName: "",
      creator: "",
      tokenId: "",
      count: "",
      contractAddress: "",
      executeiList: [],
      contractName:"",
      total: null,
      imgurlnft: require("@/assets/pc/Index/nft.png"),
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {},
  mounted() {
    this.getContractTxLists();
  },
  watch: {
    $route: {
      handler: function (to, form) {
        if (to.path === "/m/NFTslistdetail") {
          this.contractAddress = to.query.contractAddress;
          this.tokenId = to.query.tokenId;
       //   console.log(this.tokenId);

        //  console.log(this.contractAddress);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  destroyed() {},
  methods: {
    searchs(e) {
      this.address = e.address;
    },
    async getContractTxLists() {
      let formData = new FormData();
      let params = {
        tokenId: this.tokenId,
        contractAddress: this.contractAddress,
        pageNum: this.pageNum,
        pageSize: 20,
      };
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await NftItemDetail(formData);
     // console.log(res);
      this.contractName=res.result.contractName;
      this.owner = res.result.owner;
      
      if(res.result.image==''|| res.result.image==null){
        this.image=this.imgurlnft;
      }else{
        this.image = res.result.image;
      }
      this.itemName = res.result.itemName;
      this.creator = res.result.creator;
      this.tokenId = res.result.tokenId;
      this.count = res.result.count;
      this.total =res.result.count;
    //  console.log(this.total);
      this.contractAddress = res.result.contractAddress;
      this.executeiList = res.result.executeList;
    //  console.log(this.executeiList);
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      for (var i = 0; i < this.executeiList.length; i++) {
        this.executeiList[i].txHash1 = this.executeiList[i].txHash;
        this.executeiList[i].txHash = getSubStr(
          this.executeiList[i].txHash,
          0,
          6
        );
        this.executeiList[i].fromEvmAddress1 =
          this.executeiList[i].fromEvmAddress;
        this.executeiList[i].fromEvmAddress = getSubStr(
          this.executeiList[i].fromEvmAddress,
          0,
          6
        );
        this.executeiList[i].toEvmAddress1 = this.executeiList[i].toEvmAddress;
        this.executeiList[i].toEvmAddress = getSubStr(
          this.executeiList[i].toEvmAddress,
          0,
          6
        );
        let timestamp = Math.floor(this.executeiList[i].tradeTime / 1000);
        var s = strdate - timestamp;
        if (s <= 0) {
          s = 1;
        }
        this.executeiList[i].tokenAmount =
          this.executeiList[i].tokenAmount.split(",")[0];
        this.executeiList[i].tradeTime = formatSeconds(s);
      }
    },

    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      this.getContractTxLists();
    },

    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("Sorry, copy failed！");
    },
    Overview(index) {
      this.$router.push({
        path: "/m/NftOveraddress",
        query: { contractAddress: index },
      });
    },
    goDetail(name, query) {
     //  console.log(query);
      switch (name) {
        case "hash":
      
          this.$router.push({
            path: "/m/TransferDetails",
            query: {
              txHash: query.txHash1,
              type: 8,
              standard: query.standard,
            },
          });

          break;
        case "transfer":
          this.$router.push({
            path: "/m/Address",
            query: { address: query },
          });
          break;
 
      }
    },

    gltimea(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
};
</script>
<style lang="less">
.el-message {
  margin-top: 120px !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  border: none;
}
.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
</style>
<style lang="less" scoped>
.el-pagination {
  padding-bottom: 32px !important;
  margin-top: 32px;
}
.indexs {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;
  .content_top {
    margin: 30px auto 0px auto;
    width: 702px;
    background: #0b0c0f;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
  }
  .headimg {
    width: 654px;
    // height: 800px;
    // background: #0052fe;
    border-radius: 33px 33px 33px 33px;
    opacity: 1;
    margin: 56px auto 36px auto;
    img {
      width: 654px;
      min-height: 400px;
      // height: 800px;
      border-radius: 33px 33px 33px 33px;
    }
  }
  .head {
    width: 702px;
    padding: 24px 12px;
    // margin:32px 0 32px 32px;
    background: #0b0c0f;
    opacity: 1;
    border-radius: 16px 16px 16px 16px;
    padding-left: 30px;
    text-align: left;
    height: 48px;
    font-size: 32px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    line-height: 48px;
    span {
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #b2b7c2;
      line-height: 36px;
    }
  }
  .content_center {
    text-align: left;
    padding: 40px 0px 40px 0px;
    font-size: 26px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: normal;
    color: #adb0c7;
    // line-height: 36px;
    // border-bottom: 1px solid #3c485c;
    margin: 0px 32px;
    .borernone {
      border-bottom: none !important;
    }
    .bkheight {
      height: 140px !important;
    }
    .disx {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      height: 108px !important;
      border-bottom: none !important;
    }
    .block_height {
      height: 122px;
      margin-top: 28px;
      border-bottom: 1px solid #22252e;
      .block_tit {
        font-size: 26px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #8a8a8a;
        height: 36px;
        line-height: 36px;
      }
 
      .block_con {
        font-size: 26px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        height: 36px;
        line-height: 36px;
        margin-top: 12px;
        display: flex;
        span {
          height: 36px;
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #898b8d;
          line-height: 36px;
          margin-left: 10px;
        }
        .block_hasha {
          width: 334px;
          height: 72px;
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;
          line-height: 36px;
          word-wrap: break-word;
          margin-right: 160px;
        }
        .block_hash {
          width: 565px;
          height: 72px;
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;
          line-height: 36px;
          word-wrap: break-word;
        }
        img {
          width: 40px;
          height: 40px;
          margin-left: 10px;
        }
      }
      .block_cona {
        font-size: 26px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #8d8d8d;
        line-height: 36px;
        width: 652px;
        overflow: hidden;
text-overflow:ellipsis;
white-space: nowrap;

        margin-top: 28px;
        word-wrap: break-word;
      }
      .blockconss {
        word-break: break-all;
      }
    }
  }
  .translist {
    width: 100%;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .Block_Top {
      text-align: left;
      width: 702px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      background: #0b0c0f;
      border-radius: 24px 24px 0 0;
      span {
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
      }
      b {
        margin-left: 10px;
      }
    }
    //轮播图片开始
    .resume-list {
      width: 702px;
      background: #0b0c0f;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        //display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        // width: 100%;
        margin: 0;
        padding: 0;
        background: #0b0c0f;
        // overflow: hidden;
        // border: 1px solid red;
        width: 702px;
        .tabbox {
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 42px;
          text-align: left;
          margin: 24px 0 24px 24px;
        }
      }
      .indexContent {
        overflow: hidden;
        .Contractit {
          display: flex;
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #898b8d;
          line-height: 42px;
          margin-left: 24px;
          .Contrat {
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #898b8d;
            line-height: 42px;
          }
          .Contrac {
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 42px;
            margin-left: 24px;
          }
        }
        .nftlist {
          width: 702px;
          margin: 0 auto;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          // margin-left: 24px;
          .nft_box {
            //  margin-left: 12px;
            //  margin-right: 12px;
            //  margin-top: 34px;
            margin: 34px 12px;
            text-align: left;
            // margin: 34px 24px;
            .nft_img {
              width: 315px;
              height: 392px;
              background: #0052fe;
              border-radius: 16px 16px 16px 16px;
              opacity: 1;
              img {
                width: 315px;
                height: 392px;
                background: #0052fe;
                border-radius: 16px 16px 16px 16px;
              }
            }
            .take {
              height: 34px;
              font-size: 24px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              line-height: 34px;
              margin-top: 24px;
              span {
                color: #fff;
              }
            }
            .takeid {
              margin-top: 16px;
              height: 34px;
              font-size: 24px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              line-height: 34px;
              span {
                color: #fff;
              }
            }
          }
        }
        .Contracoent {
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 42px;
          text-align: left;
          margin-left: 24px;
          margin-top: 44px;
        }
        .Contrac_img {
          margin-left: 410px;
          margin-bottom: 24px;
          img {
            width: 60px;
            height: 60px;
            margin-right: 44px;
          }
        }
        .Contrant {
          width: 654px;
          height: 624px;
          background: #13161b;
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
          margin: 0 auto;
          overflow: hidden;
        }
        .Block_list1 {
          .block_list_Top1 {
            display: flex;
            width: 1700px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 300px;
            }
            li:nth-child(2) {
              width: 200px;
            }
            li:nth-child(3) {
              width: 400px;
            }
            li:nth-child(4) {
              width: 300px;
            }
            li:nth-child(5) {
              width: 300px;
            }
            li:nth-child(6) {
              width: 200px;
            }
          }
        }
        .Block_List_center1 {
          width: 1700px;
          ul {
            //  height: 620px;
            width: 1700px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #8A8A8A;
                text-align: left;
                // flex: 0 0 14%;
              }
            }
            li:last-child {
             // border-bottom: none;
            }
            p:nth-child(1) {
              width: 300px;
              color: #fff;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 200px;
            }
            p:nth-child(3) {
              width: 400px;
            }
            p:nth-child(4) {
              width: 300px;
              color: #fff;
            }
            p:nth-child(5) {
              width: 300px;
              color: #fff;
            }
            p:nth-child(6) {
              width: 200px;
            }
          }
        }
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1150px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 150px;
            }
            li:nth-child(2) {
              width: 600px;
              margin-right: 30px;
            }
            li:nth-child(3) {
              width: 200px;
            }
            li:nth-child(4) {
              width: 200px;
            }
          }
        }
        .Block_List_center {
          width: 1150px;
          ul {
            //  height: 620px;
            width: 1150px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
              }
              .grays {
                color: #898b8d;
              }
            }
            li:last-child {
             // border-bottom: none;
            }
            p:nth-child(1) {
              width: 150px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 600px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              margin-right: 30px;
            }
            p:nth-child(3) {
              width: 200px;
            }
            p:nth-child(4) {
              width: 200px;
            }
          }
        }
        .Block_list3 {
          .block_list_Top3 {
            display: flex;
            width: 1200px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 300px;
            }
            li:nth-child(2) {
              width: 500px;
            }
            li:nth-child(3) {
              width: 400px;
            }
          }
        }

        .Contractit {
          display: flex;
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #898b8d;
          line-height: 42px;
          margin-left: 24px;
          .Contrat {
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #898b8d;
            line-height: 42px;
          }
          .Contrac {
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 42px;
            margin-left: 24px;
          }
        }
        .Contracoent {
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 42px;
          text-align: left;
          margin-left: 24px;
          margin-top: 44px;
        }
        .Contrac_img {
          margin-left: 410px;
          margin-bottom: 24px;
          img {
            width: 60px;
            height: 60px;
            margin-right: 44px;
          }
        }
        .Contrant {
          width: 654px;
          height: 624px;
          background: #13161b;
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
          margin: 0 auto;
          overflow: hidden;
        }

        .Analysis_list {
          width: 654px;
          height: 445px;
          background: #13161b;
          border-radius: 16px 16px 16px 16px;
          //border: 1px solid red;
          opacity: 1;
          margin: 0 auto;
          margin-bottom: 40px;
          .charts {
            .chartshead {
              display: flex;
              justify-content: space-between;
              .charts_title {
                height: 42px;
                font-size: 30px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #898b8d;
                line-height: 42px;
                margin-top: 24px;
                margin-left: 24px;
              }
              .charts_r {
                position: relative;
                top: 28px;
                left: 10px;
                .hombottn {
                  z-index: 99;
                  display: flex;
                  width: 100px;
                  height: 44px;
                  background: #242931;
                  border-radius: 13px 13px 13px 13px;
                  opacity: 1;
                  // margin-top: 20px;
                  margin-right: 20px;
                  div {
                    height: 17px;
                    height: 34px;
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #ffffff;
                    line-height: 34px;
                    margin-top: 4px;
                    margin-left: 20px;
                  }
                  img {
                    width: 40px;
                    height: 40px;
                    // margin-top: 5px;
                    margin-left: 2px;
                  }
                }
                .headcontent {
                  width: 100px;
                  height: 108px;
                  background: #15171a;
                  border-radius: 6px 6px 6px 6px;
                  opacity: 1;
                  position: absolute;
                  left: 0px;
                  top: 64px;
                  z-index: 88;
                  ul {
                    // margin: 12px;
                    margin-left: 12px;
                    li:nth-child(1) {
                      margin-top: 5px;
                    }
                    li {
                      height: 21px;
                      line-height: 21px;
                      cursor: pointer;
                      font-size: 12px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      font-weight: 400;
                      color: #8e9093;
                    }
                    .active {
                      cursor: pointer;
                      color: #00a870;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }

    //轮播图片结束
  }
  .list {
    text-align: center;
    padding-bottom: 80px;
  }
  .list-data {
    margin: 30px auto 0px auto;
    width: 690px;
    background: #232a35;
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    .block {
      height: 128px;
      margin-top: 51px;
      margin-bottom: 50px;
      font-size: 28px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      line-height: 39px;
    }
    .head {
      display: -webkit-box;
    }
  }
  .headall {
    position: relative;
    .sousu1 {
      height: 56px;
      background: #2c3645;
      border-radius: 16px 16px 0 0;
      opacity: 1;

      display: flex;
      margin-top: 24px;
      margin-right: 32px;
      justify-content: space-between;
      align-content: center;
      span {
        height: 44px;
        margin-left: 16px;
        margin-top: 8px;
        font-size: 24px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.55);
        line-height: 44px;
      }
      img {
        width: 48px;
        height: 48px;
        margin: 0 !important;
        margin-top: 8px !important;
      }
    }
    .sousu {
      height: 56px;
      background: #2c3645;
      border-radius: 16px 16px 16px 16px;
      opacity: 1;

      display: flex;
      margin-top: 24px;
      margin-right: 32px;
      justify-content: space-between;
      align-content: center;
      span {
        width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 44px;
        margin-left: 16px;
        margin-top: 8px;
        font-size: 24px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.55);
        line-height: 44px;
      }
      img {
        width: 48px;
        height: 48px;
        margin: 0 !important;
        margin-top: 8px !important;
      }
    }

    .headcontent {
      width: 294px;
      background: #2c3645;
      border-radius: 0px 0px 16px 16px;
      opacity: 1;
      position: absolute;
      right: 0px;
      top: 80px;
      ul {
        margin: 12px;
        li {
          height: 44px;
          line-height: 44px;
          font-size: 28px;
          font-family: SF Pro Text-Regular, SF Pro Text;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.9);
        }
        .active {
          color: #00a870;
        }
      }
    }
  }
  .head {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 690px;
    // height: 100px;
    opacity: 1;
    padding-left: 30px;
    text-align: left;
    font-size: 32px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    // line-height: 100px;
    .address {
      width: 400px;
      color: rgba(255, 255, 255, 0.9);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    span {
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      text-align: left;
      color: rgba(255, 255, 255, 0.9);
      line-height: 100px;
    }
    img {
      width: 45px;
      height: 45px;
      margin: 20px 30px 40px 0px;
    }
  }
  .content_img {
    img {
      width: 476px;
      height: 318px;
      margin: 100px 20px;
    }
  }

  // .content_center {
  //   text-align: left;
  //   padding: 40px 0px 40px 0px;
  //   font-size: 28px;
  //   font-family: SF Pro Text-Medium, SF Pro Text;
  //   font-weight: 500;
  //   color: #adb0c7;
  //   line-height: 36px;
  //   border-bottom: 1px solid #3c485c;
  //   margin: 0px 32px;
  //   div {
  //     display: flex;
  //     margin-top: 16px;
  //     flex-direction: row;
  //     justify-content: space-between;
  //     height: 44px;
  //     line-height: 44px;
  //     font-size: 28px;
  //     font-family: SF Pro Text-Medium, SF Pro Text;
  //     font-weight: 500;
  //     color: rgba(255, 255, 255, 0.55);
  //   }
  //   span {
  //     padding-bottom: 10px;
  //     text-align: left;
  //     float: right;
  //     height: 44px;
  //     font-size: 28px;
  //     font-family: SF Pro Text-Regular, SF Pro Text;
  //     font-weight: 400;
  //     color: #00a870;
  //     line-height: 44px;
  //     overflow: hidden;
  //     white-space: nowrap;
  //     text-overflow: ellipsis;
  //     width: 420px;
  //   }
  //   .black {
  //     height: 44px;
  //     font-size: 28px;
  //     font-family: SF Pro Text-Regular, SF Pro Text;
  //     font-weight: 400;
  //     color: rgba(255, 255, 255, 0.9);
  //     line-height: 44px;
  //   }
  //   span:nth-child(4) {
  //     color: #2c3852 !important;
  //   }
  //   span:nth-child(5) {
  //     color: #2c3852 !important;
  //   }
  //   img {
  //     width: 45px;
  //     height: 45px;
  //   }
  // }
}
</style>
